import { useQuery } from '@tanstack/react-query';

import { sessionRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useIsImpersonated = () => {
  const query = useQuery({
    queryKey: [QueryKeys.IS_IMPERSONATED],
    queryFn: sessionRepo.getIsImpersonated,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: Infinity,
  });

  return useQueryMemoized(query);
};

export type UseIsImpersonated = ReturnType<typeof useIsImpersonated>;
